var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBarMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h18v2H0V0zm6 7h12v2H6V7zm-6 7h18v2H0v-2z",
    fill: "#222",
    fillRule: "nonzero"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarMenu);
export default __webpack_public_path__ + "static/media/bar-menu.d395aeb516513ae3cf393e059f62447f.svg";
export { ForwardRef as ReactComponent };